export enum WhatsAppTemplateStatusEnum {
  approved = 'approved',
  rejected = 'rejected',
  paused = 'paused',
  pending = 'pending',
  deleted = 'deleted',
  pending_deletion = 'pending_deletion',
  in_appeal = 'in_appeal',
  not_migrated_to_cloudapi = 'not_migrated_to_cloudapi',
  limit_exceeded = 'limit_exceeded',
  bsp_temporary = 'bsp_temporary',
}
